<div>
    <h6 class="h6Title">Editar sesiones</h6>
    <hr>
</div>

<div>
    <table>
        <!-- Table header -->
        <tr>
            <th scope="col" class="w-05">ID</th>
            <th scope="col" class="w-05">#</th>
            <th scope="col" class="w-50">Título</th>
            <th scope="col" class="w-05">Archivos</th>
            <th scope="col" class="w-05">Vigente</th>
            <th scope="col" class="w-05">Tipo</th>
        </tr>

        <!-- Table data -->
        <tr *ngFor="let modulo of clases; let i=index">
            <td>
                {{modulo.id}}
            </td>
            <td class="pd0">
                <input type="number" [(ngModel)]=modulo.numero [ngModelOptions]="{standalone: true}" class="w-100 ft12">
            </td>
            <td>
                <a (click)="editarModulo(modulo.id, content)" class="grayLink">
                    {{modulo.titulo}}
                </a>
            </td>
            <td class="centertext">{{modulo.archivos.length}}</td>

            <td class="pd0 mg0 centertext">
                <select [(ngModel)]="modulo.vigente" [ngModelOptions]="{standalone: true}" name="vigente" class="fw">
                    <option [ngValue]="true">Si</option>
                    <option [ngValue]="false">No</option>
                </select>
            </td>
            <td class="centertext">{{modulo.tipo}}</td>
        </tr>
    </table>
</div>

<ng-template #content let-modal>

    <div class="pd10 ">
        <div class="pdb05 border-b">
            <span class="ft15" (click)="mostrarInfo='info'"
                [ngClass]=" {'ft500 ft500 gray-9':mostrarInfo === 'info'}">Info</span>
            <span *ngIf="modulo.tipo === 'lectura'" (click)="mostrarInfo='contenido'" class="mgl20 ft15"
                [ngClass]=" {'ft500 gray-9':mostrarInfo === 'contenido'}">Contenido</span>
            <span *ngIf="modulo.tipo === 'pdf'" (click)="mostrarInfo='pdf'" class="mgl20 ft15"
                [ngClass]=" {'ft500 gray-9':mostrarInfo === 'pdf'}">PDF</span>
        </div>


        <!-- ----------------------------------------------------------------------- editar informacion general del curso -->
        <div *ngIf="mostrarInfo === 'info'">
            <!-- numero -->
            <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1.5rem">
                <div class="mgt10 w100px column">
                    <label for="numero">Numero</label>
                    <input type="number" [(ngModel)]="modulo.numero" [ngModelOptions]="{standalone: true}" class="fw">
                </div>
                <!-- duracion -->
                <div class="mgt10 w100px column">
                    <label for="duracion">Duración</label>
                    <input type="number" [(ngModel)]="modulo.duracion" [ngModelOptions]="{standalone: true}" class="fw">
                </div>
                <div class="mgt10 w150px column">
                    <label for="tipo">Tipo</label>
                    <select [(ngModel)]="modulo.tipo" [ngModelOptions]="{standalone: true}" class="fw">
                        <option value="null" disabled selected>Seleccione el tipo de modulo</option>
                        <option value="video">video</option>
                        <option value="lectura">lectura</option>
                        <option value="pdf">PDF</option>
                    </select>
                </div>
                <!-- link -->
                <div class="mgt10 column" *ngIf="modulo.tipo == 'video'">
                    <label for="link">Id del video</label>
                    <input [(ngModel)]="modulo.idVideo" [ngModelOptions]="{standalone: true}" class="fw">
                </div>
                <!-- titulo -->
                <div class="mgt10 fw column">
                    <label for="titulo">Titulo</label>
                    <input [(ngModel)]="modulo.titulo" [ngModelOptions]="{standalone: true}" class="fw">
                </div>

            </div>

            <!-- descripcion -->
            <div class="mgt10 fw column">
                <label for="descripcion">Descripción</label>
                <textarea maxlength="500" [(ngModel)]="modulo.descripcion" [ngModelOptions]="{standalone: true}"
                    class="fw"></textarea>
            </div>

            <!-- archivos -->
            <div class="w-60">
                <div class="mgt10 pdb05" fxLayout="row" fxLayoutAlign=" center">
                    <span class="ft500 ft14">Archivos</span>
                    <div class="mgl10">
                        <label class="mg0 gray-9 ft16 ft500 cursorPointer"> +
                            <input type="file" (change)="anadirArchivo($event)" name="file" autocomplete="off"
                                style="display: none;" />
                        </label>
                    </div>
                </div>

                <div *ngFor="let archivo of modulo.archivos; let i = index;">
                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="1.5rem"
                        class="pdt05 fw border-t pdb05">
                        <div fxFlex="90%">
                            <span class="mgl10 gray-5">{{i}} </span>
                            <span class="mgl20 fw">{{modulo.archivos[i].nombre}}</span>
                        </div>
                        <div fxFlex="10%">
                            <span class="blueLink" (click)="deleteArchivo(i)">Eliminar</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- buttons -->
            <div class="mgt30">
                <button *ngIf="editar" type="button" class="grayButton gray-9 ft500 ft11 mgr10"
                    (click)="eliminarModulo(modulo.id)">
                    Eliminar</button>
                <button type="button" class="darkButton gray-2 ft500 ft11" (click)="guardarModulo(modulo.id)">
                    Guardar Modulo
                </button>
            </div>
        </div>

        <!-- ----------------------------------------------------------------------- editar contenido de lectura -->
        <div *ngIf="mostrarInfo === 'contenido'">
            <!-- angular editor -->
            <div class="fw">
                <angular-editor [(ngModel)]="modulo.HTMLcontent" [ngModelOptions]="{standalone: true}" [config]="config"
                    class="angularEditor"></angular-editor>

                <div class="mgt20 pdb05 border-b">
                    <span class="ft500 ft14">HTML Output</span>
                </div>
                <div class="htmlOutput">
                    <span class="ft12"> {{ modulo.HTMLcontent }}</span>
                </div>

            </div>
        </div>
        <!-- ----------------------------------------------------------------------- editar contenido de lectura -->
        <div *ngIf="mostrarInfo === 'pdf'">
            <!-- angular editor -->
            <input (change)="cargarPDF($event)" type="file">
        </div>
    </div>
</ng-template>

<div class="mgt10 mgb40" fxLayout="row" fxLayoutGap="1rem">
    <button (click)="anadirModulo(content)" class="grayButton gray-9 ft500 ft11">Agregar módulo</button>
    <button type="button" class="grayButton gray-8 ft500 ft11" (click)="actualizarProgresos()">Actualizar
        Progresos</button>
    <button type="button" class="darkButton gray-2 ft500 ft11" (click)="guardarSesion()">Guardar Sesiones</button>
</div>